import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ac290b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column margin-lr" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "font-size-14" }
const _hoisted_4 = { class: "d-flex flex-column margin-top-10" }
const _hoisted_5 = { class: "font-size-14" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_7 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_8 = {
  key: 0,
  class: "margin-top-10 d-flex flex-column"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_10 = {
  key: 1,
  class: "margin-top-10 d-flex flex-column"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_12 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_13 = {
  key: 0,
  class: "margin-right-10 d-flex align-items-center"
}
const _hoisted_14 = {
  key: 2,
  class: "margin-top-10 d-flex flex-column"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_16 = { class: "margin-top-10 d-flex flex-column padding-top-10" }
const _hoisted_17 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_19 = { class: "d-flex flex-column margin-top-10" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_21 = {
  key: 3,
  class: "margin-top-10"
}
const _hoisted_22 = { id: "formAuthType" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_24 = { class: "d-flex flex-column margin-top-10" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_26 = {
  key: 4,
  class: "margin-top-10"
}
const _hoisted_27 = { id: "tokenAuthType" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_29 = { class: "d-flex flex-column margin-top-10" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_31 = {
  key: 5,
  class: "margin-top-10"
}
const _hoisted_32 = { id: "apiKeyAuthType" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_34 = { class: "d-flex flex-column margin-top-10" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_36 = {
  key: 6,
  class: "margin-top-10"
}
const _hoisted_37 = { id: "oAuthType" }
const _hoisted_38 = { class: "d-flex flex-column" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_40 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_42 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_43 = {
  key: 0,
  class: "d-flex flex-column justify-content-center align-items-center margin-top-10"
}
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_46 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_47 = { class: "margin-top-10 margin-bottom-10 card-footer d-flex justify-content-end connection-footer" }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "loader-div-sm" }
const _hoisted_50 = ["src"]

import {
  computed,
  defineAsyncComponent,
  onBeforeMount,
  onMounted,
  provide,
  ref,
  watch,
} from "vue";
import { ElInput, ElOption, ElSelect, ElButton, ElSwitch } from "element-plus";
import { TYPE } from "vue-toastification";
import { JsonForms } from "@jsonforms/vue";
import { createAjv } from "@jsonforms/core";
import { cloneDeep } from "lodash-es";
import { currentRoute } from "@/core/router";
import {
  convertObject,
  convertToDefinitions,
  disconnectOAuth,
  getConnection,
  getConnectorAuthSchemas,
  getConnectorSpecById,
  getOAuthUrl,
  getOrganizationsConnectorList,
  saveConnection,
  verifyOauth,
  StepConnection,
} from "@/connection/services/connection.service";
import { showAlert, showConfirm } from "@/core/popup";
import { hasPermission } from "@/core/auth";
import { isAuthValid } from "@/connection/utils/authValidation";
import i18n from "@/core/i18n/i18n";
import {
  defaultRenderers as renderers,
  styles,
} from "@/core/json-forms/json-forms";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";

interface SettingsData {
  name: string;
  schema: any;
  data: any;
  description: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectionForm',
  props: {
    index: {},
    specId: {},
    connectors: {},
    oldConnection: {},
    stepConnection: {},
    nameExist: { type: Boolean },
    stepIdx: {},
    selectedOrgId: {},
    connectionId: {}
  },
  emits: ["update", "check-name", "update-connection-valid"],
  setup(__props: any, { emit: __emit }) {

provide("styles", styles);

const AuthenticationForm = defineAsyncComponent(
  () => import("@/connection/components/AuthenticationForm.vue")
);

const props = __props;
const emit = __emit;
const ajv = createAjv({ useDefaults: true });
const { t } = i18n.global;
const connectorList = ref([]);
const selectedSpec = ref();
const id = ref();
const connectionId = ref();
const specLoading = ref(false);
const stepConnection = ref<StepConnection>();
const additionalSettingsErrorMap = ref(new Map());
const selectedConnectorSpecId = ref();
const connection = ref(defaultConnection());
const selectedLanguage = ref("en");
const responseLoading = ref(false);

const dataList = ref(new Array<SettingsData>());
const clicked = ref(false);
const verified = ref(false);
const isPasswordFieldClicked = ref(false);
const isSecretFieldClicked = ref(false);
const holdPassword = ref("");
const holdClientSecret = ref("");
const representPassword = ref("");
const representClientSecret = ref("");

const authObject = ref({
  authenticationType: undefined,
  oauth: {
    clientId: "",
    clientSecret: "",
    callbackUrl: "",
    endPoint: undefined,
    accessToken: undefined,
    refreshToken: undefined,
    tokenExpiry: undefined,
  },
  basicAuth: {
    endPoint: undefined,
    username: undefined,
    password: undefined,
  },
  formAuth: {
    form: undefined,
    authentication: undefined,
    endPoint: undefined,
  },
  tokenAuth: {
    authToken: undefined,
    endPoint: undefined,
  },
  apiKeyAuth: {
    apiKey: undefined,
    nameInHeader: undefined,
  },
});

const authItems = ref();
const authMap = ref(new Map());

// AJV errors for the auth forms, reported by AuthenticationForm and used by authIsValid.
const authErrors = ref([]);

function convertToAuth(map) {
  const obj = {};
  map.forEach((value, key) => {
    if (key === "custom") {
      connection.value.authentication.authenticationType = "CUSTOM";
    } else if (key === "oauth") {
      connection.value.authentication.authenticationType = "Oauth";
    } else if (key === "bearer") {
      connection.value.authentication.authenticationType = "BEARER";
    } else if (key === "postads") {
      connection.value.authentication.authenticationType = "POSTADS";
    } else if (key === "apiKey") {
      connection.value.authentication.authenticationType = "Api_key";
    } else if (key === "basic") {
      connection.value.authentication.authenticationType = "Basic";
    } else if (key.toLowerCase() === "jwt") {
      connection.value.authentication.authenticationType = "JWT";
    } else if (key.toLowerCase() === "awssigv4") {
      connection.value.authentication.authenticationType = "AWS_SIGV4";
    } else if (key.toLowerCase() === "woodwingstudio") {
      connection.value.authentication.authenticationType = "WOODWING_STUDIO";
    }
    // The backend now reports the type for each scheme. Prefer it, so a newly added
    // scheme works without a UI change; the branches above remain as a fallback for
    // backends that predate that field.
    if (value.authenticationType) {
      connection.value.authentication.authenticationType =
        value.authenticationType;
    }
    if (!value.flows) {
      obj[key] = convertToDefinitions(value.data);
    } else {
      obj[key] = convertToAuth(value.flowData);
    }
  });
  return obj;
}

const additionalSettings = computed(() => {
  const obj = {};
  dataList.value.forEach((data) => {
    obj[data.name] = {
      name: data.name,
      description: data.description,
      connectionSettingDefinitions: convertToDefinitions(data.data),
    };
  });
  return obj;
});
function defaultConnection() {
  return {
    name: undefined,
    authentication: {
      authenticationType: undefined,
      oauth: {
        clientId: "",
        clientSecret: "",
        callbackUrl: "",
        endPoint: undefined,
        accessToken: undefined,
        refreshToken: undefined,
        tokenExpiry: undefined,
      },
      basicAuth: {
        endPoint: undefined,
        username: undefined,
        password: undefined,
      },
      formAuth: {
        form: undefined,
        authentication: undefined,
        endPoint: undefined,
      },
      tokenAuth: {
        authToken: undefined,
        endPoint: undefined,
      },
      apiKeyAuth: {
        apiKey: undefined,
        nameInHeader: undefined,
      },
    },
    connector: {
      active: true,
      camelComponentName: undefined,
      connectorSpecId: undefined,
      createdAt: undefined,
      createdBy: {
        id: undefined,
      },
      connectorType: undefined,
      description: undefined,
      hasConsumer: false,
      id: undefined,
      modifiedBy: {
        id: undefined,
      },
      name: undefined,
      organisation: {
        id: undefined,
        createdBy: {
          id: undefined,
        },
        modifiedBy: {
          id: undefined,
        },
      },
      pricingType: undefined,
      updatedAt: undefined,
    },
    additionalSettings: undefined,
    authParams: undefined,
    // Both are primitive booleans server-side, so omitting them persists false —
    // silently disabling SSL validation. EditConnection.vue sends true; match it so
    // connections created through this embedded form are not weaker than those made
    // on the Connections page. Editing keeps whatever the stored connection has.
    sslValidation: true,
    followRedirects: true,
  };
}

const isValid = computed(
  () => connection.value.name && connection.value.connector && !hasError()
);

const oauthResult = ref({
  state: "",
  authorizeUrl: "",
});

function onDataChange(event, index, settingsData) {
  const entries = Object.entries(event.data);
  entries.forEach(([key, val]: any[]) => {
    // Repeatable inputs hold an array value; leave it intact.
    if (Array.isArray(val)) {
      return;
    }
    let parsedVal = val;
    try {
      const parsed = JSON.parse(val);
      if (Array.isArray(parsed) && parsed[0]?.name) {
        parsedVal = parsed[0].name;
      }
    } catch (error) {
      parsedVal = val;
    }
    event.data[key] = parsedVal;
  });
  settingsData.data = event.data;
  additionalSettingsErrorMap.value.set(index, event.errors);
  dataList.value.splice(index, 1, settingsData);
}

function updateAuth(data) {
  authMap.value = cloneDeep(data);
}

function emptyPassword() {
  isPasswordFieldClicked.value = true;
  representPassword.value = "";
  authObject.value.basicAuth.password = "";
}

function emptyClientSecret() {
  isSecretFieldClicked.value = true;
  representClientSecret.value = "";
  authObject.value.oauth.clientSecret = "";
}

function hasError() {
  let error = false;
  additionalSettingsErrorMap.value.forEach((item) => {
    if (item.length) {
      error = true;
    }
  });
  return error;
}

onMounted(() => {
  splitRoute();
  watch(
    () => currentRoute.value.path,
    () => {
      splitRoute();
    }
  );
});

async function createOrUpdateConnection() {
  responseLoading.value = true;
  if (isPasswordFieldClicked.value) {
    authObject.value.basicAuth.password =
      representPassword.value !== "*****" ? representPassword.value : "";
  } else {
    authObject.value.basicAuth.password = holdPassword.value;
  }
  if (isSecretFieldClicked.value) {
    authObject.value.oauth.clientSecret =
      representClientSecret.value !== "*****"
        ? representClientSecret.value
        : "";
  } else {
    authObject.value.oauth.clientSecret = holdClientSecret.value;
  }
  if (canSave.value) {
    // Same gate as the Connections page: turning off certificate validation must be
    // confirmed explicitly, so an embedded form cannot silently weaken a connection.
    if (!connection.value.sslValidation) {
      const confirmed = await showConfirm(
        "warning",
        t("Connection.SSLDisabled"),
        t("Connection.SSLDisabledMessage")
      );
      if (!confirmed) {
        responseLoading.value = false;
        return;
      }
    }
    connection.value.authentication = authObject.value;
    connection.value.additionalSettings = additionalSettings.value;
    connection.value.authParams = JSON.stringify(convertToAuth(authMap.value));
    await saveConnection(connection.value, props.selectedOrgId).then(
      (response) => {
        if (response) {
          if (connectionId.value) {
            showAlert(TYPE.SUCCESS, t("Connection.ConnectorUpdated"));
          } else {
            connectionId.value = response.id;
            // Keep `id` in step: the OAuth verify/disconnect calls and the id handed
            // to AuthenticationForm read it, and they would otherwise act on "".
            id.value = response.id;
            connection.value = response;
            showAlert(TYPE.SUCCESS, t("Connection.ConnectionCreated"));
          }
          if (
            // Optional chaining: an unmapped auth scheme leaves this undefined, and
            // throwing here skipped the update-connection-valid emit entirely.
            authObject.value.authenticationType?.toLowerCase() === "oauth" &&
            connectionId.value
          ) {
            checkOauth();
          } else {
            emit("update-connection-valid", true);
          }
        }
      }
    );
  } else if (hasPermission("CONNECTIONS.CONNECTION.SAVE")) {
    showAlert(TYPE.WARNING, t("Connection.WarningMsg"));
  }
  responseLoading.value = false;
}

async function checkOauth() {
  if (
    authObject.value.authenticationType?.toLowerCase() === "oauth" &&
    connectionId.value
  ) {
    const response = await getOAuthUrl(connectionId.value, props.selectedOrgId);
    if (response) {
      oauthResult.value = response;
      if (oauthResult.value.authorizeUrl) {
        openUrl();
      }
    }
  }
}

function openUrl() {
  if (oauthResult.value.authorizeUrl) {
    const width = 450;
    const height = 510;

    const openWindow = window.open(
      oauthResult.value.authorizeUrl,
      "",
      `
      width=${width},
      height=${height},
      `
    );
    const timer = setInterval(() => {
      if (openWindow.closed) {
        getAuthUrl().then(() => {
          emit("update-connection-valid", true);
        });
        clearInterval(timer);
      }
    }, 1000);
    clicked.value = true;
  }
}

async function verifyLogin() {
  if (id.value) {
    verifyOauth(id.value).then((resp) => {
      if (resp) {
        if (resp.state === "CONNECTED") {
          verified.value = true;
          oauthResult.value.state = resp.state;
        }
      }
    });
  }
}

async function disconnectFromOAuth() {
  if (oauthResult.value.state === "CONNECTED") {
    const response = await disconnectOAuth(id.value);
    if (response) {
      verified.value = false;
      oauthResult.value.state = "DISCONNECTED";
      if (!connection.value.authentication.oauth) {
        await getAuthUrl();
      }
      if (connection.value.authentication.oauth.accessToken) {
        connection.value.authentication.oauth.accessToken = undefined;
      }
      if (connection.value.authentication.oauth.refreshToken) {
        connection.value.authentication.oauth.refreshToken = undefined;
      }
      if (connection.value.authentication.oauth.tokenExpiry) {
        connection.value.authentication.oauth.tokenExpiry = undefined;
      }
    }
  }
}

watch(
  () => connection.value.name,
  async () => {
    if (connection.value.name !== "") {
      emit("check-name", connection.value);
      if (!props.nameExist) {
        sendData();
      }
    }
  },
  { deep: true }
);

const authIsValid = computed(() =>
  isAuthValid({
    authItems: authItems.value,
    authMap: authMap.value,
    authErrors: authErrors.value,
    authenticationType: connection.value.authentication.authenticationType,
    authObject: authObject.value,
  })
);

const canSave = computed(() => !!isValid.value && authIsValid.value);

watch(
  () => authObject.value,
  () => {
    if (authIsValid.value) {
      connection.value.authentication = authObject.value;
    }
  },
  { deep: true }
);

watch(
  () => connection.value,
  () => {
    sendData();
  },
  { deep: true }
);

watch(
  () => selectedConnectorSpecId.value,
  async () => {
    specLoading.value = true;
    // try/finally so the loader always clears. The connector spec request is large
    // (multiple MB for action-heavy connectors), so a failed, slow or aborted call is
    // a realistic outcome; previously any error here rejected the watcher before
    // specLoading was reset, leaving the form spinning forever.
    try {
      if (selectedConnectorSpecId.value) {
        await onSpecChange();
        // Only enforce membership when the backend actually supplied the list. The
        // spec is undefined when its request failed, and treating that as "not
        // supported" would silently clear the user's selected auth type.
        const supportedAuthTypes = selectedSpec.value?.supportedAuthTypes;
        if (
          supportedAuthTypes &&
          !supportedAuthTypes.includes(
            connection.value.authentication.authenticationType
          )
        ) {
          connection.value.authentication.authenticationType = undefined;
        }

        connection.value.connector = connectorList.value.find(
          (item) => item.connectorSpecId === selectedConnectorSpecId.value
        );
        authItems.value = await getConnectorAuthSchemas(
          selectedConnectorSpecId.value
        );
        await getAuthUrl();
        if (connection.value.authParams) {
          authMap.value = convertDataToAuthList(
            JSON.parse(connection.value.authParams),
            authItems.value
          );
        }
      } else {
        selectedSpec.value = undefined;
      }
    } catch (error) {
      // Drop the previous connector's metadata rather than leaving it rendered against
      // a different selectedConnectorSpecId. The connector reference itself is left
      // alone: a transient failure should not discard the user's selection.
      selectedSpec.value = undefined;
      authItems.value = undefined;
      dataList.value = [];
      showAlert(TYPE.ERROR, t("Common.UnknownError"));
    } finally {
      specLoading.value = false;
    }
  }
);

watch(
  () => representPassword.value,
  () => {
    if (
      representPassword.value === "*****" ||
      representPassword.value !== holdPassword.value.substring(0, 10)
    ) {
      isPasswordFieldClicked.value = true;
      authObject.value.basicAuth.password = "";
    } else {
      isPasswordFieldClicked.value = false;
    }
  }
);
watch(
  () => representClientSecret.value,
  () => {
    if (
      representClientSecret.value === "*****" ||
      representClientSecret.value !== holdClientSecret.value.substring(0, 10)
    ) {
      isSecretFieldClicked.value = true;
      authObject.value.oauth.clientSecret = "";
    } else {
      isSecretFieldClicked.value = false;
    }
  }
);

async function onSpecChange() {
  if (selectedConnectorSpecId.value) {
    dataList.value = [];
    await getConnectorSpecById(selectedConnectorSpecId.value).then((resp) => {
      if (resp) {
        selectedSpec.value = resp.spec;
        if (selectedSpec.value.connectionSettingsSchemas) {
          if (connection.value.additionalSettings) {
            convertDataToList(connection.value.additionalSettings);
          } else {
            convertToEmptyDataList(
              selectedSpec.value.connectionSettingsSchemas
            );
          }
        } else {
          dataList.value = [];
          connection.value.additionalSettings = {};
        }
      }
    });
  }
}

function convertToEmptyDataList(list) {
  list.forEach((schema) => {
    dataList.value.push({
      schema,
      name: schema.title,
      description: schema.description,
      data: {},
    });
  });
}

function convertDataToList(data) {
  if (data) {
    if (Object.keys(data).length !== 0) {
      Object.values(data).forEach((value: any) => {
        const objSchema = selectedSpec.value.connectionSettingsSchemas.find(
          (item) => item.title === value.name
        );
        if (objSchema) {
          dataList.value.push({
            schema: objSchema,
            name: value.name,
            description: value.description,
            data: convertObject(value.connectionSettingDefinitions),
          });
        }
      });
    } else {
      convertToEmptyDataList(selectedSpec.value.connectionSettingsSchemas);
    }
  }
}

watch(
  () => connection.value.authentication.authenticationType,
  async () => {
    authObject.value.authenticationType =
      connection.value.authentication.authenticationType;
    if (authObject.value.authenticationType === "OAUTH" && connectionId.value) {
      const resp = await getOAuthUrl(connectionId.value, props.selectedOrgId);
      if (resp) {
        oauthResult.value = resp;
        if (oauthResult.value.state === "CONNECTED") {
          verified.value = true;
        }
      }
      await verifyLogin();
    }
  }
);

async function getAuthUrl() {
  if (connectionId.value) {
    const resp = await getOAuthUrl(connectionId.value, props.selectedOrgId);
    if (resp) {
      oauthResult.value = resp;
      if (oauthResult.value.state === "CONNECTED") {
        verified.value = true;
      }
    }
  }
}

function convertDataToAuthList(data, list) {
  const dataMap = new Map();
  if (data && list) {
    if (Object.keys(data).length !== 0) {
      Object.entries(data).forEach(([key, value]: any[]) => {
        const objSchema = list.find((item: { name: any }) => item.name === key);
        if (objSchema !== undefined) {
          dataMap.set(key, {
            name: objSchema.name,
            schema: objSchema.uiSchema,
            // Carried through so convertToAuth uses the type the backend reports for the
            // scheme; without it a re-opened connection falls back to the name mapping and
            // re-persists a mixed-case type ("Oauth", "Basic", "Api_key").
            authenticationType: objSchema.authenticationType,
            requiresBrowserAuthentication:
              objSchema.requiresBrowserAuthentication
                ? objSchema.requiresBrowserAuthentication
                : false,
            flows: objSchema.flows,
            data: objSchema.flows ? {} : convertObject(value),
            flowData: objSchema.flows
              ? convertDataToAuthList(value, objSchema.flows)
              : new Map(),
          });
        }
      });
    }
  }
  return dataMap;
}

function splitRoute() {
  const getCurrentLanguage = currentRoute.value.path.split("/");
  if (getCurrentLanguage[1] === "en") {
    selectedLanguage.value = "english";
  } else {
    selectedLanguage.value = "turkish";
  }
}
function sendData() {
  // eslint-disable-next-line max-len
  if (isValid.value && !props.nameExist && !props.stepConnection.selectedName) {
    // Only publish settings once dataList has been built. This runs from deep
    // watchers that fire on mount, while onSpecChange is still awaiting the
    // connector spec — assigning the (empty) computed then would wipe the settings
    // of a connection loaded for editing, since connection is the same object.
    if (dataList.value.length) {
      connection.value.additionalSettings = additionalSettings.value;
    }
    stepConnection.value.connection = connection.value;
    emit("update", props.index, stepConnection.value);
  }
}

onBeforeMount(() => {
  connectorList.value = (props.connectors || []).filter(
    (c: any) => !c.connectionOptional
  );
  selectedConnectorSpecId.value = props.specId;
  stepConnection.value = props.stepConnection;
  if (props.oldConnection) {
    connection.value = props.oldConnection;
    authObject.value.authenticationType =
      props.oldConnection.authenticationType;
    if (props.oldConnection.authentication.authenticationType === "BASIC") {
      authObject.value.basicAuth = props.oldConnection.authentication.basicAuth;
    } else if (
      props.oldConnection.authentication.authenticationType === "TOKEN"
    ) {
      authObject.value.tokenAuth = props.oldConnection.authentication.tokenAuth;
    } else if (
      props.oldConnection.authentication.authenticationType === "OAUTH"
    ) {
      authObject.value.oauth = props.oldConnection.authentication.oauth;
    } else if (
      props.oldConnection.authentication.authenticationType === "FORM"
    ) {
      authObject.value.formAuth = props.oldConnection.authentication.formAuth;
    }
  }
});

onBeforeMount(async () => {
  getOrganizationsConnectorList().then((connectorListDB) => {
    // Connection-optional connectors are used without a Connection, so they are not offered here.
    connectorList.value = (connectorListDB || []).filter(
      (c: any) => !c.connectionOptional
    );
  });

  // The connection id comes from the caller, never from the route. This component is
  // always embedded in another screen (`/flows/edit/:id/:version`,
  // `/flows/export/:id/:version`), where `params.id` is the FLOW id — reading it here
  // issued a bogus connection fetch, could clobber the seeded draft, and pointed the
  // OAuth sign-in/verify buttons at the wrong id.
  // Both refs identify the same connection: `id` drives the OAuth verify/disconnect
  // calls and what AuthenticationForm receives, while `connectionId` drives the
  // save path and OAuth URL loading. They must be set together or editing looks
  // like creation and the OAuth handlers act on an empty id.
  id.value = props.connectionId ?? "";
  connectionId.value = id.value;
  if (id.value) {
    await getConnection(id.value).then((response) => {
      if (response) {
        connection.value = response;
        selectedConnectorSpecId.value = response.connector.connectorSpecId;
        authObject.value.authenticationType = response.authenticationType;
        if (response.authentication.authenticationType === "BASIC") {
          authObject.value.basicAuth = response.authentication.basicAuth;
          holdPassword.value = authObject.value.basicAuth.password;
          // Show the masked sentinel, never a slice of the stored ciphertext.
          representPassword.value = "*****";
        } else if (response.authentication.authenticationType === "TOKEN") {
          authObject.value.tokenAuth = response.authentication.tokenAuth;
        } else if (response.authentication.authenticationType === "OAUTH") {
          authObject.value.oauth = response.authentication.oauth;
          holdClientSecret.value = authObject.value.oauth.clientSecret;
          representClientSecret.value = "*****";
        } else if (response.authentication.authenticationType === "FORM") {
          authObject.value.formAuth = response.authentication.formAuth;
        } else if (response.authentication.authenticationType === "API_KEY") {
          authObject.value.apiKeyAuth = response.authentication.apiKeyAuth;
        }
      }
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _createTextVNode(_toDisplayString(_unref(t)("Common.Connector")) + " : ", 1),
        _createElementVNode("strong", null, _toDisplayString(connection.value.connector ? connection.value.connector.name : ""), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_unref(t)("Connection.ConnectionName")), 1),
          _hoisted_6
        ])
      ]),
      _createVNode(_unref(ElInput), {
        modelValue: connection.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((connection.value.name) = $event)),
        id: "connection-name",
        disabled: stepConnection.value.selectedName !== '',
        placeholder: _unref(t)('Connection.ConnectionName')
      }, null, 8, ["modelValue", "disabled", "placeholder"])
    ]),
    (!specLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (settingsData, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "margin-top-10 d-flex flex-column",
              key: settingsData.name
            }, [
              _createElementVNode("label", null, [
                _createElementVNode("strong", null, _toDisplayString(settingsData.name), 1)
              ]),
              (_openBlock(), _createBlock(_unref(JsonForms), {
                data: settingsData.data,
                key: settingsData.schema,
                schema: settingsData.schema,
                ajv: _unref(ajv),
                disabled: stepConnection.value.selectedName !== '',
                renderers: _unref(renderers),
                onChange: ($event: any) => (onDataChange($event, index, settingsData))
              }, null, 8, ["data", "schema", "ajv", "disabled", "renderers", "onChange"]))
            ]))
          }), 128)),
          (authItems.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("strong", null, [
                  _createTextVNode(_toDisplayString(_unref(t)("Connection.Authentication")), 1),
                  _hoisted_9
                ]),
                _createVNode(_unref(AuthenticationForm), {
                  "auth-list": authItems.value,
                  data: authMap.value,
                  multiple: false,
                  "auth-result": oauthResult.value,
                  onUpdate: updateAuth,
                  onErrors: _cache[1] || (_cache[1] = ($event: any) => (authErrors.value = $event)),
                  onVerifyLogin: verifyLogin,
                  verified: verified.value,
                  clicked: clicked.value,
                  "connection-id": id.value,
                  onDisconnectFromOauth: disconnectFromOAuth,
                  onOpenUrl: openUrl
                }, null, 8, ["auth-list", "data", "auth-result", "verified", "clicked", "connection-id"])
              ]))
            : _createCommentVNode("", true),
          (selectedSpec.value && !authItems.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("strong", null, [
                  _createTextVNode(_toDisplayString(_unref(t)("Connection.Authentication")), 1),
                  _hoisted_11
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(ElSelect), {
                    modelValue: connection.value.authentication.authenticationType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((connection.value.authentication.authenticationType) = $event)),
                    filterable: "",
                    id: "connection-authentication-type",
                    size: "small",
                    disabled: stepConnection.value.selectedName !== '',
                    placeholder: _unref(t)('Common.SelectAuth')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSpec.value.supportedAuthTypes, (item, index) => {
                        return (_openBlock(), _createBlock(_unref(ElOption), {
                          id: 'connection-authentication-option-' + index,
                          label: item,
                          value: item,
                          key: item
                        }, null, 8, ["id", "label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled", "placeholder"]),
                  (oauthResult.value.state)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (connection.value.authentication.authenticationType === 'OAUTH')
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              class: _normalizeClass(
                oauthResult.value.state === 'DISCONNECTED'
                  ? 'color-red'
                  : 'color-green'
              )
                            }, _toDisplayString(oauthResult.value.state), 3))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (
          connection.value.authentication.authenticationType === 'BASIC' && !authItems.value
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", null, [
                    _createElementVNode("strong", null, [
                      _createTextVNode(_toDisplayString(_unref(t)("User.UserName")), 1),
                      _hoisted_15
                    ])
                  ]),
                  _createVNode(_unref(ElInput), {
                    modelValue: authObject.value.basicAuth.username,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((authObject.value.basicAuth.username) = $event)),
                    id: "connection-basic-username",
                    size: "small",
                    placeholder: _unref(t)('User.UserName'),
                    style: {"height":"5px"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", _hoisted_17, [
                    _createElementVNode("strong", null, [
                      _createTextVNode(_toDisplayString(_unref(t)("Common.Password")), 1),
                      _hoisted_18
                    ])
                  ]),
                  _createVNode(_unref(ElInput), {
                    modelValue: representPassword.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((representPassword).value = $event)),
                    id: "connection-basic-password",
                    type: "password",
                    size: "small",
                    "show-password": "",
                    placeholder: _unref(t)('Common.Password'),
                    onClick: emptyPassword
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", null, [
                    _createElementVNode("strong", null, [
                      _createTextVNode(_toDisplayString(_unref(t)("Common.Endpoint")), 1),
                      _hoisted_20
                    ])
                  ]),
                  _createVNode(_unref(ElInput), {
                    modelValue: authObject.value.basicAuth.endPoint,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((authObject.value.basicAuth.endPoint) = $event)),
                    id: "connection-basic-endpoint",
                    size: "small",
                    placeholder: _unref(t)('Common.Endpoint')
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ]))
            : _createCommentVNode("", true),
          (
          connection.value.authentication.authenticationType === 'FORM' && !authItems.value
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", null, [
                    _createElementVNode("strong", null, [
                      _createTextVNode(_toDisplayString(_unref(t)("Common.Form")), 1),
                      _hoisted_23
                    ])
                  ]),
                  _createVNode(_unref(ElInput), {
                    modelValue: authObject.value.formAuth.form,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((authObject.value.formAuth.form) = $event)),
                    id: "connection-formAuth-form",
                    size: "small",
                    placeholder: _unref(t)('Common.Form')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", null, [
                    _createElementVNode("strong", null, [
                      _createTextVNode(_toDisplayString(_unref(t)("Common.Endpoint")), 1),
                      _hoisted_25
                    ])
                  ]),
                  _createVNode(_unref(ElInput), {
                    modelValue: authObject.value.formAuth.endPoint,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((authObject.value.formAuth.endPoint) = $event)),
                    id: "connection-formAuth-endpoint",
                    size: "small",
                    placeholder: _unref(t)('Common.Endpoint')
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ]))
            : _createCommentVNode("", true),
          (
          connection.value.authentication.authenticationType === 'TOKEN' && !authItems.value
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", null, [
                    _createElementVNode("strong", null, [
                      _createTextVNode(_toDisplayString(_unref(t)("Connection.AuthToken")), 1),
                      _hoisted_28
                    ])
                  ]),
                  _createVNode(_unref(ElInput), {
                    modelValue: authObject.value.tokenAuth.authToken,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((authObject.value.tokenAuth.authToken) = $event)),
                    id: "connection-tokenAuth-token",
                    size: "small",
                    placeholder: _unref(t)('Connection.AuthToken')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", null, [
                    _createElementVNode("strong", null, [
                      _createTextVNode(_toDisplayString(_unref(t)("Common.Endpoint")), 1),
                      _hoisted_30
                    ])
                  ]),
                  _createVNode(_unref(ElInput), {
                    modelValue: authObject.value.tokenAuth.endPoint,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((authObject.value.tokenAuth.endPoint) = $event)),
                    id: "connection-tokenAuth-endpoint",
                    size: "small",
                    placeholder: _unref(t)('Common.Endpoint')
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ]))
            : _createCommentVNode("", true),
          (
          connection.value.authentication.authenticationType === 'API_KEY' &&
          !authItems.value
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", null, [
                    _createElementVNode("strong", null, [
                      _createTextVNode(_toDisplayString(_unref(t)("Connection.ApiKey")), 1),
                      _hoisted_33
                    ])
                  ]),
                  _createVNode(_unref(ElInput), {
                    modelValue: authObject.value.apiKeyAuth.apiKey,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((authObject.value.apiKeyAuth.apiKey) = $event)),
                    id: "connection-apiKeyAuth-apiKey",
                    placeholder: _unref(t)('Connection.ApiKey')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("label", null, [
                    _createElementVNode("strong", null, [
                      _createTextVNode(_toDisplayString(_unref(t)("Connection.ApiKeyName")), 1),
                      _hoisted_35
                    ])
                  ]),
                  _createVNode(_unref(ElInput), {
                    modelValue: authObject.value.apiKeyAuth.nameInHeader,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((authObject.value.apiKeyAuth.nameInHeader) = $event)),
                    id: "connection-apiKeyAuth-nameInHeader",
                    placeholder: _unref(t)('Connection.ApiKeyName')
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ]))
            : _createCommentVNode("", true),
          (
          connection.value.authentication.authenticationType === 'OAUTH' && !authItems.value
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", null, [
                      _createElementVNode("strong", null, [
                        _createTextVNode(_toDisplayString(_unref(t)("Common.ClientId")), 1),
                        _hoisted_39
                      ])
                    ]),
                    _createVNode(_unref(ElInput), {
                      modelValue: authObject.value.oauth.clientId,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((authObject.value.oauth.clientId) = $event)),
                      id: "connection-authObject-client-id",
                      size: "small",
                      placeholder: _unref(t)('Common.ClientId')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("label", null, [
                      _createElementVNode("strong", null, [
                        _createTextVNode(_toDisplayString(_unref(t)("Common.ClientSecret")), 1),
                        _hoisted_41
                      ])
                    ]),
                    _createVNode(_unref(ElInput), {
                      modelValue: representClientSecret.value,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((representClientSecret).value = $event)),
                      id: "connection-authObject-client-secret",
                      type: "password",
                      size: "small",
                      onClick: emptyClientSecret,
                      placeholder: _unref(t)('Common.ClientSecret')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("label", null, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.CallbackUrl")), 1)
                    ]),
                    _createVNode(_unref(ElInput), {
                      modelValue: authObject.value.oauth.callbackUrl,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((authObject.value.oauth.callbackUrl) = $event)),
                      disabled: true,
                      id: "connection-authObject-callback-url",
                      size: "small",
                      placeholder: _unref(t)('Common.CallbackUrl')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  (id.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        (oauthResult.value.state === 'DISCONNECTED')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "google-button",
                              disabled: !oauthResult.value.authorizeUrl,
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (openUrl()))
                            }, _toDisplayString(_unref(t)("Common.SignIn")), 9, _hoisted_44))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "google-button",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (disconnectFromOAuth()))
                            }, _toDisplayString(_unref(t)("Common.SignOut")), 1)),
                        (clicked.value && id.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "google-button margin-top-10",
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (verifyLogin()))
                            }, _toDisplayString(!verified.value ? _unref(t)("Common.Verify") : _unref(t)("Common.Verified")), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("label", null, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.SSLValidation")), 1)
            ]),
            _createVNode(_unref(ElSwitch), {
              "active-color": "#5022a6",
              modelValue: connection.value.sslValidation,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((connection.value.sslValidation) = $event)),
              disabled: stepConnection.value.selectedName !== '',
              onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("label", null, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.FollowRedirects")), 1)
            ]),
            _createVNode(_unref(ElSwitch), {
              "active-color": "#5022a6",
              modelValue: connection.value.followRedirects,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((connection.value.followRedirects) = $event)),
              disabled: stepConnection.value.selectedName !== '',
              onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", null, [
              _createVNode(_unref(ElButton), {
                class: "btn-oneTeg2",
                id: "connection-submit",
                type: "primary",
                disabled: !canSave.value,
                onClick: createOrUpdateConnection
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("Common.Save")) + " " + _toDisplayString(_unref(t)("Common.Connection")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _withDirectives(_createElementVNode("div", _hoisted_49, [
            _createElementVNode("img", {
              src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
              alt: "Loading...",
              class: "loader-logo-40"
            }, null, 8, _hoisted_50)
          ], 512), [
            [_vShow, specLoading.value]
          ])
        ]))
  ]))
}
}

})